
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#fff"}},[_c('path',{attrs:{"d":"M35.6 4.4c-5.7-5.7-14.8-5.7-20.5 0-5.7 5.7-5.7 14.8 0 20.5 5.7 5.7 14.8 5.7 20.5 0 5.7-5.6 5.7-14.8 0-20.5zm-5.3 15.2c-2.7 2.7-7.2 2.7-9.9 0s-2.7-7.2 0-9.9 7.2-2.7 9.9 0 2.7 7.2 0 9.9zM8.1 26.2l-2.3 2.4-2.3 2.3-3.3 3.3 5.6 5.6 3.3-3.3 2.3-2.3 2.4-2.3z"}})])])
          )
        }
      }
    